import { EncryptStorage } from 'encrypt-storage';

// eslint-disable-next-line import/prefer-default-export
export const encryptStorage = new EncryptStorage(
  `${process.env.REACT_APP_LOCAL_STORAGE_ENCRYPTION_SECRET_KEY}`,
  { storageType: 'localStorage' },
);
